import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type TruckModelEntity } from '@/libs/api'

import { TruckModelCreateModalContent } from './TruckModelCreateModalContent'

type Props = {
  open: boolean
  onClose: () => void
  onSuccess: (site: TruckModelEntity) => Promise<void>
  tenantKey: string
  dcId: number | undefined
}

export const TruckModelCreateModal: FC<Props> = ({
  open,
  onClose,
  onSuccess,
  tenantKey,
  dcId
}) => {
  return (
    <Modal
      title={MENU.CREATING_TRUCK_MODEL}
      width={520}
      open={open}
      onCancel={onClose}
    >
      <TruckModelCreateModalContent
        onClose={onClose}
        onSuccess={onSuccess}
        tenantKey={tenantKey}
        dcId={dcId}
      />
    </Modal>
  )
}
